'use strict';
import classNames from 'classnames';
import isFunction from 'lodash/isFunction';
import * as T from 'prop-types';
import React, {Component} from 'react';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/delay';
import {ListDivider} from '../../../components/lists/ListDivider';
import {StatusOverlayComponent} from '../../../core-components/loading-icon/components/StatusOverlayComponent';
import {ViewModePropType} from '../../../core-utilities/enums/ViewMode';
import {I18nComponent} from '../../../core-utilities/react-i18n/I18nComponent';
import {ActiveTimerList} from '../../../timers/components/ActiveTimerList';
import {UserTodoMessageList} from '../../../todo-messages/components/TodoMessageList/UserTodoMessageList';
import {AutoUserPinListComponent} from '../UserPinList/AutoUserPinListComponent';
import {PinnedUserPinListComponent} from '../UserPinList/PinnedUserPinListComponent';


class BaseUserHomeComponent extends Component {
  static propTypes = {
    overallMode: ViewModePropType,
    showTodoMessages: T.bool,
    showActiveTimers: T.bool,

    userId: T.string.isRequired,
    pinnedListMode: ViewModePropType.isRequired,
    autoListMode: ViewModePropType.isRequired,
    hasMorePinnedList: T.bool,
    hasMoreAutoList: T.bool,
    onLoadMorePinnedList: T.func.isRequired,
    onLoadMoreAutoList: T.func.isRequired,
    onClickItem: T.func.isRequired,
    onItemContextMenu: T.func.isRequired,
    onClickTodoMessageAction: T.func.isRequired,
    onClickTodoAction: T.func.isRequired,

    hideTitle: T.string.isRequired,
    showTitle: T.string.isRequired,
    pinsTitle: T.string.isRequired,
    todoMessagesTitle: T.string.isRequired,
    todoMessagePlaceholder: T.string.isRequired,
    timersTitle: T.string.isRequired,
    prioritiesTitle: T.string.isRequired,
    prioritiesPlaceholderTitle: T.string.isRequired,
    radarPlaceholder: T.string.isRequired,
    thisMonthLabel: T.string.isRequired,
    unscheduledMonthLabel: T.string.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      showTodoMessages: true,
      showTimers: true,
      showPins: true,
      showRadar: true,
    };
    this.handleToggleShowTodoMessages = this.handleToggleShowTodoMessages.bind(this);
    this.handleToggleShowTimers = this.handleToggleShowTimers.bind(this);
    this.handleToggleShowPins = this.handleToggleShowPins.bind(this);
    this.handleToggleShowRadar = this.handleToggleShowRadar.bind(this);
    this.handleClickTodoAction = this.handleClickTodoAction.bind(this);
  }

  handleToggleShowTodoMessages(e) {
    e.preventDefault();
    this.setState({showTodoMessages: !this.state.showTodoMessages});
  }

  handleToggleShowTimers(e) {
    e.preventDefault();
    this.setState({showTimers: !this.state.showTimers});
  }

  handleToggleShowPins(e) {
    e.preventDefault();
    this.setState({showPins: !this.state.showPins});
  }

  handleToggleShowRadar(e) {
    e.preventDefault();
    this.setState({showRadar: !this.state.showRadar});
  }

  handleClickTodoAction(e, model, actionId) {
    e.preventDefault();

    if (isFunction(this.props.onClickTodoAction)) {
      this.props.onClickTodoAction(model, actionId);
    }
  }

  render() {
    const props = this.props;
    const todoMessagesHeader = this.renderHeader(
      props.todoMessagesTitle,
      this.state.showTodoMessages,
      this.handleToggleShowTodoMessages,
      props.todoMessagesState,
    );
    const todoMessages = (
      <UserTodoMessageList
        className={classNames('home-section', {
          'home-section-collapsed': !this.state.showTodoMessages,
        })}
        itemClassName={props.itemClassName}
        showNoDataIcon={false}
        canScroll={false}
        placeholderTitle={props.todoMessagePlaceholder}
        thisMonthLabel={props.thisMonthLabel}
        loadMoreLabel={props.loadMoreLabel}

        // item actions
        onClickItem={props.onClickItem}
        onClickAction={props.onClickTodoMessageAction}
      />
    );
    const activeTimersHeader = this.renderHeader(
      props.timersTitle,
      this.state.showTimers,
      this.handleToggleShowTimers,
      props.activeTimersState,
    );
    const activeTimers = (
      <ActiveTimerList
        wrapperClassName={classNames('home-section', {
          'home-section-collapsed': !this.state.showTimers,
        })}
        itemClassName={props.itemClassName}
        showNoDataIcon={false}
        onClickItem={props.onClickItem}
      />
    );
    const pinnedListHeader = this.renderHeader(
      props.pinsTitle,
      this.state.showPins,
      this.handleToggleShowPins,
      props.pinnedListState,
    );
    const pinnedList = (
      <PinnedUserPinListComponent
        wrapperClassName={classNames('home-section', {
          'home-section-collapsed': !this.state.showPins,
        })}
        itemClassName={props.itemClassName}
        showNoDataIcon={false}
        canScroll={false}
        placeholderTitle={props.radarPlaceholder}
        thisMonthLabel={props.thisMonthLabel}
        unscheduledMonthLabel={props.unscheduledMonthLabel}
        loadMoreLabel={props.loadMoreLabel}

        // item actions
        onClickItem={props.onClickItem}
        onItemContextMenu={props.onItemContextMenu}
      />
    );
    const autoListHeader = this.renderHeader(
      props.prioritiesTitle,
      this.state.showRadar,
      this.handleToggleShowRadar,
      props.autoListState,
    );
    const autoList = (
      <AutoUserPinListComponent
        wrapperClassName={classNames('home-section', {
          'home-section-collapsed': !this.state.showRadar,
        })}
        itemClassName={props.itemClassName}
        showNoDataIcon={false}
        canScroll={false}
        placeholderTitle={props.prioritiesPlaceholderTitle}
        thisMonthLabel={props.thisMonthLabel}
        unscheduledMonthLabel={props.unscheduledMonthLabel}
        loadMoreLabel={props.loadMoreLabel}

        // item actions
        onClickItem={props.onClickItem}
        onItemContextMenu={props.onItemContextMenu}
      />
    );

    return (
      <div className={classNames("UserHome", props.className)}>
        {props.overallMode ? (
          <StatusOverlayComponent mode={props.overallMode} />
        ) : null}

        {this.renderSmall(
          todoMessagesHeader,
          todoMessages,
          activeTimersHeader,
          activeTimers,
          pinnedListHeader,
          pinnedList,
          autoListHeader,
          autoList,
          !!props.overallMode,
        )}
      </div>
    );
  }

  renderSmall(
    todoMessagesHeader,
    todoMessages,
    activeTimersHeader,
    activeTimers,
    pinnedListHeader,
    pinnedList,
    autoListHeader,
    autoList,
    hide,
  ) {
    return (
      <div
        className={classNames({
          UserHome__content_hide: hide,
        })}
      >
        <div
          className={classNames("UserHome__smallList", {
            UserHome__smallList_hide: !this.props.showTodoMessages,
          })}
        >
          {todoMessagesHeader}

          {todoMessages}
        </div>
        <div
          className={classNames("UserHome__smallList", {
            UserHome__smallList_hide: !this.props.showActiveTimers,
          })}
        >
          {activeTimersHeader}

          {activeTimers}
        </div>
        <div className="UserHome__smallList">
          {pinnedListHeader}

          {pinnedList}
        </div>
        <div className="UserHome__smallList">
          {autoListHeader}

          {autoList}
        </div>
      </div>
    );
  }

  renderHeader(title, showList, handleToggleShow, totalState) {
    let total;
    if (totalState.isFiltered && (totalState.filteredTotal !== totalState.total)) {
      total = `(${totalState.filteredTotal} / ${totalState.total})`;
    } else {
      total = `(${totalState.total})`;
    }

    return (
      <ListDivider
        label={`${title} ${total}`}
        showFilter={true}
        isToggled={!showList}
        onClickToggle={handleToggleShow}
        iconShowTitle={this.props.showTitle}
        iconHideTitle={this.props.hideTitle}
      />
    );
  }
}

export const UserHomeComponent = I18nComponent(BaseUserHomeComponent, [
  {code: 'icon.hide.title', prop: 'hideTitle'},
  {code: 'icon.show.title', prop: 'showTitle'},
  {code: 'user.home.todoMessages', prop: 'todoMessagesTitle'},
  {code: 'user.home.todoMessages.placeholder', prop: 'todoMessagePlaceholder'},
  {code: 'user.home.timers', prop: 'timersTitle'},
  {code: 'user.home.pins', prop: 'pinsTitle'},
  {code: 'user.home.priorities', prop: 'prioritiesTitle'},
  {code: 'user.home.priorities.placeholder', prop: 'prioritiesPlaceholderTitle'},
  {code: 'user.home.radar.placeholder', prop: 'radarPlaceholder'},
  {code: 'user.home.this.month.label', prop: 'thisMonthLabel'},
  {code: 'user.home.unscheduled.month.label', prop: 'unscheduledMonthLabel'},
  {code: 'default.button.load.more.label', prop: 'loadMoreLabel'},
]);



// WEBPACK FOOTER //
// ./src/js/priorities/components/UserHome/UserHomeComponent.js